/**
 * Utility function that creates links to JSP pages
 *
 * @param {string} jspFileName The name of the JSP file
 * @param {string} jspDirectory The directory path of the JSP file. Optional
 * @param {string} queryKey The name of a query param. Optional
 * @param {string} queryValue The value of a query param. Optional
 *
 */

export const generateLink = _ref => {
  let {
    jspFileName,
    jspDirectory = '',
    queryKey = '',
    queryValue = ''
  } = _ref;
  if (typeof window === 'undefined') {
    return '#';
  }
  const {
    location: {
      href
    }
  } = window;
  const currentDirectory = href.substring(0, href.lastIndexOf('/'));
  const directory = jspDirectory || currentDirectory;
  const queryString = queryKey && queryValue ? `?${encodeURIComponent(queryKey)}=${encodeURIComponent(queryValue)}` : '';
  const link = `${directory}/${jspFileName}.jsp${queryString}`;
  return link;
};